module.exports = __webpack_public_path__ + "img/VM Logo Gray-Blue-White RGB.c6854d3c.jpg";